import { useEffect, useState } from "react";
import { Send, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-2.5 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold text-sm";

export default function AdminNewsletter() {
    const [subs, setSubs] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ subject: "", body_html: "" });

    const load = () => {
        api.get("/admin/newsletter/subscribers").then((r) => setSubs(r.data));
        api.get("/admin/newsletter/campaigns").then((r) => setCampaigns(r.data));
    };
    useEffect(() => { load(); }, []);

    const create = async (e) => {
        e.preventDefault();
        const html = form.body_html.split("\n\n").map((p) => `<p>${p.replace(/\n/g, "<br/>")}</p>`).join("");
        await api.post("/admin/newsletter/campaigns", { subject: form.subject, body_html: html });
        toast.success("Campaign drafted"); setOpen(false); setForm({ subject: "", body_html: "" }); load();
    };
    const send = async (id) => {
        if (!window.confirm(`Send to ${subs.filter((s) => s.active).length} subscribers?`)) return;
        const { data } = await api.post(`/admin/newsletter/campaigns/${id}/send`);
        toast.success(`Sent to ${data.recipient_count} subscribers`); load();
    };

    return (
        <div>
            <h1 className="font-serif text-4xl text-cream mb-6">Newsletter</h1>
            <Tabs defaultValue="campaigns">
                <TabsList className="bg-surface2 border border-gold/15">
                    <TabsTrigger value="campaigns" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Campaigns</TabsTrigger>
                    <TabsTrigger value="subscribers" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Subscribers ({subs.length})</TabsTrigger>
                </TabsList>

                <TabsContent value="campaigns" className="mt-6">
                    <div className="flex justify-end mb-4">
                        <Dialog open={open} onOpenChange={setOpen}>
                            <DialogTrigger asChild>
                                <button data-testid="new-campaign-btn" className="inline-flex items-center gap-2 bg-gold text-ink rounded-full px-5 py-2.5 text-sm font-medium hover:bg-goldbright"><Plus className="w-4 h-4" /> New Campaign</button>
                            </DialogTrigger>
                            <DialogContent className="bg-surface2 border-gold/20 text-cream max-w-lg">
                                <DialogHeader><DialogTitle className="font-serif text-2xl">New Campaign</DialogTitle></DialogHeader>
                                <form onSubmit={create} className="space-y-3">
                                    <input required placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={input} />
                                    <textarea required rows={8} placeholder="Write your message… (blank line = new paragraph)" value={form.body_html} onChange={(e) => setForm({ ...form, body_html: e.target.value })} className={input} />
                                    <button className="w-full bg-gold text-ink rounded-full py-2.5 font-medium">Save Draft</button>
                                </form>
                            </DialogContent>
                        </Dialog>
                    </div>
                    <div className="space-y-3">
                        {campaigns.map((c) => (
                            <div key={c.id} className="p-4 rounded-xl bg-surface border border-gold/10 flex items-center justify-between">
                                <div>
                                    <div className="text-cream">{c.subject}</div>
                                    <div className="text-xs text-faded">{c.status === "sent" ? `Sent to ${c.recipient_count} · ${new Date(c.sent_at).toLocaleDateString()}` : "Draft"}</div>
                                </div>
                                {c.status !== "sent" && <button onClick={() => send(c.id)} className="inline-flex items-center gap-2 text-gold text-sm border border-gold/30 rounded-full px-4 py-2 hover:bg-gold/10"><Send className="w-4 h-4" /> Send</button>}
                            </div>
                        ))}
                        {campaigns.length === 0 && <p className="text-ash">No campaigns yet.</p>}
                    </div>
                </TabsContent>

                <TabsContent value="subscribers" className="mt-6">
                    <div className="rounded-2xl border border-gold/10 overflow-hidden">
                        <table className="w-full text-sm">
                            <thead className="bg-surface2 text-faded text-left"><tr><th className="p-4">Email</th><th className="p-4">Name</th><th className="p-4">Joined</th></tr></thead>
                            <tbody>
                                {subs.map((s) => (
                                    <tr key={s.id} className="border-t border-gold/10"><td className="p-4 text-cream">{s.email}</td><td className="p-4 text-ash">{s.name || "-"}</td><td className="p-4 text-ash">{new Date(s.subscribed_at).toLocaleDateString()}</td></tr>
                                ))}
                            </tbody>
                        </table>
                        {subs.length === 0 && <p className="text-ash p-4">No subscribers yet.</p>}
                    </div>
                </TabsContent>
            </Tabs>
        </div>
    );
}
